import Vue from 'vue'
import 'bootstrap'

import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import VueSocialSharing from 'vue-social-sharing'
import VueAnalytics from 'vue-analytics'

import routes from './router'
import guards from './router/guards'
import messages from './i18n'
import './assets/main.scss'

Vue.config.productionTip = false

Vue.use(VueSocialSharing)
Vue.use(VueRouter)
Vue.use(VueI18n)

const render = h => h('div', { attrs: { id: 'app' } }, [
  h('RouterView')
])

const i18n = new VueI18n({ locale: 'es', messages })
const mode = ''
const router = guards({ router: new VueRouter({ routes, mode }), i18n })

Vue.use(VueAnalytics, {
  id: 'UA-3419264-1',
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: '/' + route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

new Vue({ router, render, i18n }).$mount('#app')